import React from 'react';
import { NavLink } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { Grid } from '@material-ui/core';
import { makeChooseClassStyles } from 'styles/pages/ApplicationClassSection';
import { texts } from './texts';

const renderClassTile = (key, application) => {
  const { classTile, classTileWrapper, classTileWrapperSingle } = makeChooseClassStyles();

  return (
    <Box key={key} className={`${classTileWrapper} ${classTileWrapperSingle} class-${key}`}>
      <NavLink key={key} className={`${classTile} `} to={`/klasa-${key}/${application}-${key}`}>
        <div className="number">{key}</div>klasa
      </NavLink>
    </Box>
  );
};

const ChooseClass = ({application}) => {
  const { background, gridContainer, h3, wrapper } = makeChooseClassStyles();
  const classesNumbers = texts.apps[application].classesNumbers;

  return (
    <div className={background}>
      <Container>
        <Grid container justify="center">
          <Grid item xs={11}>
            <h3 className={h3} style={{ textAlign: 'center' }}>Wybierz klasę</h3>
            <Grid container className={gridContainer} justify="center" spacing={4}>
              <Grid className="item" item xs={7} sm={9} md={8} lg={7}>
                <Box
                  className={wrapper}
                  display={{ xs: 'flex' }}
                  justifyContent="center"
                  flexWrap="wrap"
                >
                  {classesNumbers.map( (key) => renderClassTile(key, application) )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ChooseClass;
